
























import { Component, Vue } from "vue-property-decorator";

@Component
export default class RulePopup extends Vue {
  rule: string = "";
  isShowRule: boolean = false;
  showRule(val: boolean) {
    this.isShowRule = typeof val === undefined ? !this.isShowRule : val;
  }
  setRule(rule: string) {
    this.rule = rule;
  }
}
